import React from 'react'
import Button from '@mui/material/Button'
import { styled } from '@mui/material'

interface ITagProps {
  title: string
}

const StyledButton = styled(Button)(({ theme }) => ({
  marginLeft: '20px',
  borderRadius: '10px',
  width: 'auto',
  height: '25px',
  fontSize: '0.5rem',
  '&.Mui-disabled': {
    color: theme.palette.primary.dark,
    borderColor: theme.palette.primary.dark,
  },
}))

export const Tag: React.FC<ITagProps> = ({ title }) => {
  return (
    <StyledButton variant="outlined" disabled>
      {title}
    </StyledButton>
  )
}
